import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const GET_USER = 'GET_USER'
export const getUserApi = apiCall(GET_USER, () => ({
  endpoint: getApiUrl('/api/cms/v1/user'),
  method: 'GET',
  headers: appApiHeaders(),
}))

const UPDATE_USER = 'UPDATE_USER'
export const updateUserApi = apiCall(
  UPDATE_USER,
  (params: { name?: string }) => ({
    endpoint: getApiUrl('/api/cms/v1/user'),
    method: 'PATCH',
    headers: appApiHeaders(),
    body: params,
  }),
)

const GET_USER_STATS = 'GET_USER_STATS'
export const getUserStatsApi = apiCall(GET_USER_STATS, () => ({
  endpoint: getApiUrl('/api/cms/v1/user/stats'),
  method: 'GET',
  headers: appApiHeaders(),
}))
